import { useQuery } from "@apollo/client/react";
import type { SortDirection } from "../../../models/SortDirection";
import GET_CLIENT_ASSESSMENT_INVOICES from "../../queries/invoices/getClientAssessmentInvoices";
import type { InvoiceAssessmentResponseModel } from "../../../models/InvoiceAssessment";
import type { InvoiceTag } from "../../../models/InvoiceTags";
import type { InvoiceProcessStatus } from "../../../models/InvoiceStatusModel";
import type { InvoiceSortBy } from "../../../models/InvoiceSortBy";

export type ClientFilterType = "ISSUER" | "ISSUER_AND_RECIPIENT" | "RECIPIENT";

interface UseClientAssessmentInvoicesOptions {
  sortBy?: InvoiceSortBy;
  sortDirection?: SortDirection;
  invoiceStatuses?: InvoiceProcessStatus[];
  tags?: InvoiceTag[];
  skip?: number;
  take?: number;
  searchTerm?: string;
  clientFilterType?: ClientFilterType;
  disabled?: boolean;
}

export const useClientAssessmentInvoices = (
  clientIdentifier: string,
  options: UseClientAssessmentInvoicesOptions = {},
) => {
  const {
    sortBy,
    sortDirection,
    invoiceStatuses,
    tags,
    skip,
    take,
    searchTerm,
    clientFilterType,
    disabled,
  } = options;

  const { data, error, loading, refetch } = useQuery<{
    invoices: InvoiceAssessmentResponseModel;
  }>(GET_CLIENT_ASSESSMENT_INVOICES, {
    variables: {
      clientIdentifier,
      sortBy,
      sortDirection,
      invoiceStatuses,
      tags,
      skip,
      take,
      searchTerm: searchTerm || undefined,
      clientFilterType: clientFilterType || undefined,
    },
    errorPolicy: "all",
    skip: disabled,
  });
  return { invoices: data?.invoices, error, loading, refetch };
};
